export const isValidBase64Image = (base64: string = ''): boolean => {
  if (!base64) {
    return false;
  }

  const base64ImageRegex = /^data:image\/(png|jpg|jpeg|gif|bmp|webp);base64,[A-Za-z0-9+/]+={0,2}$/;

  return base64ImageRegex.test(base64.trim());
};
